export const API_USER = `${process.env.REACT_APP_MS_API_URL}/user`;
export const API_GRADE = `${process.env.REACT_APP_MS_API_URL}/grade`;
export const API_ABSENCE = `${process.env.REACT_APP_MS_API_URL}/absence`;
export const API_HOMEWORK = `${process.env.REACT_APP_MS_API_URL}/homework`;
export const API_ASSIST = `${process.env.REACT_APP_MS_API_URL}/assist`;
export const API_NOTICE = `${process.env.REACT_APP_MS_API_URL}/notice`;
export const API_INVOICE = `${process.env.REACT_APP_MS_API_URL}/invoice`;
export const API_ENROLL = `${process.env.REACT_APP_MS_API_URL}/enroll`;
export const API_UPLOAD = `${process.env.REACT_APP_MS_API_URL}/upload`;